import i18next from 'i18next';

/**
 * Get the error message for the given error code.
 * @param {string} errorCode - The error code to get the message for.
 * @param {string} [genericI18nKey] - The generic i18n key to use if the error code is not found.
 * @returns {string} The error message
 */
export const getErrorMessage = (errorCode, genericI18nKey = 'generic') => {
  if (errorCode.startsWith('API response do not match')) {
    return i18next.t('apiErrors.schemaMismatch');
  }
  if (i18next.exists(`apiErrors.${errorCode}`)) {
    return i18next.t(`apiErrors.${errorCode}`);
  }
  return i18next.t(`apiErrors.${genericI18nKey}`);
};
